/* search-bar.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
var _22 = "._irr31ojv:hover{background-color:rgba(205,214,244,.1)}";
var _21 = "._19itglyw{border:none}";
var _20 = "._1wyb1crf{font-size:9pt}";
var _19 = "._k48p1nn1{font-weight:400}";
var _18 = "._19bvi2wt{padding-left:6px}";
var _17 = "._n3tdi2wt{padding-bottom:6px}";
var _16 = "._u5f3i2wt{padding-right:6px}";
var _15 = "._ca0qi2wt{padding-top:6px}";
var _14 = "._1idr7woi::placeholder{color:rgba(205,214,244,.2)}";
var _13 = "._1idr7woi::-moz-placeholder{color:rgba(205,214,244,.2)}";
var _12 = "._syaz1ds0{color:#b4befe}";
var _11 = "._12y31o36{outline-width:medium}";
var _10 = "._1qu2glyw{outline-style:none}";
var _9 = "._12ji1r31{outline-color:currentColor}";
var _8 = "._19it1jxw{border:var(--_rsy7xm)}";
var _7 = "._11q71j28{background:transparent}";
var _6 = "._18u01y44{margin-left:4px}";
var _5 = "._otyr1y44{margin-bottom:4px}";
var _4 = "._2hwx1y44{margin-right:4px}";
var _3 = "._19pk1y44{margin-top:4px}";
var _2 = "._zulp1y44{gap:4px}";
var _ = "._1e0c1txw{display:flex}";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useState } from "react";
import theme from "../theme";
var buttonStyles = null;
var inputStyles = null;
var searchBarWrapperStyles = null;
var SearchBar = function SearchBar(_ref) {
  var onSearch = _ref.onSearch;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var handleInputChange = useCallback(function (event) {
    setQuery(event.target.value);
    onSearch(event.target.value);
  }, [onSearch]);
  var handleSearch = useCallback(function () {
    onSearch(query);
  }, [query, onSearch]);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _zulp1y44 _19pk1y44 _2hwx1y44 _otyr1y44 _18u01y44"])
  }, /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_7, _8, _9, _10, _11, _12, _13, _14]), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: "Search here",
    value: query,
    onChange: handleInputChange,
    className: ax(["_11q71j28 _19it1jxw _12ji1r31 _1qu2glyw _12y31o36 _syaz1ds0 _1idr7woi"]),
    style: {
      "--_rsy7xm": ix("1px solid " + theme.softerMain)
    }
  })), /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_12, _15, _16, _17, _18, _19, _20, _7, _21, _22]), /*#__PURE__*/React.createElement("button", {
    onClick: handleSearch,
    className: ax(["_syaz1ds0 _ca0qi2wt _u5f3i2wt _n3tdi2wt _19bvi2wt _k48p1nn1 _1wyb1crf _11q71j28 _19itglyw _irr31ojv"])
  }, "SEARCH"))));
};
export default SearchBar;